import React from 'react';
import { detailScenarios, machineDetailData, machines as machineTemplates } from './mockData';

export const TIME_RANGE_OPTIONS = [
  { key: '1m', label: '1 dk', points: 30, stepSeconds: 2, phaseStep: 1, trendScale: 1, format: { hour: '2-digit', minute: '2-digit', second: '2-digit' } },
  { key: '5m', label: '5 dk', points: 30, stepSeconds: 10, phaseStep: 1.2, trendScale: 0.72, format: { hour: '2-digit', minute: '2-digit' } },
  { key: '1h', label: '1 saat', points: 30, stepSeconds: 120, phaseStep: 1.5, trendScale: 0.38, format: { hour: '2-digit', minute: '2-digit' } },
  { key: '12h', label: '12 saat', points: 24, stepSeconds: 1800, phaseStep: 1.8, trendScale: 0.2, format: { hour: '2-digit', minute: '2-digit' } },
  { key: '24h', label: '24 saat', points: 24, stepSeconds: 3600, phaseStep: 2.1, trendScale: 0.14, format: { hour: '2-digit', minute: '2-digit' } },
];

const profiles = {
  'kirma-makinasi-1': {
    power: { base: 7.4, amp: 0.12, amp2: 0.05, speed: 1.8, speed2: 2.9, phase: 0.2, historySlope: 0.01, digits: 1, unit: 'kW' },
    airflowInstant: { base: 198, amp: 6, amp2: 3, speed: 1.7, speed2: 3.1, phase: 0.4, historySlope: 0.6, digits: 0, unit: 'L/dk' },
    airTotal: { base: 18400, increment: 38, amp: 4, amp2: 3, speed: 2.2, speed2: 3.4, phase: 0.1, digits: 0, unit: 'L' },
    pressure: { base: 6.2, amp: 0.05, amp2: 0.03, speed: 1.9, speed2: 2.8, phase: 0.1, historySlope: 0.0, digits: 1, unit: 'bar' },
    temperature: { base: 44, amp: 0.4, amp2: 0.2, speed: 2.1, speed2: 3.3, phase: 0.3, historySlope: 0.08, digits: 0, unit: '°C' },
    humidity: { base: 46, amp: 0.6, amp2: 0.3, speed: 2.3, speed2: 3.7, phase: 0.8, historySlope: 0.0, digits: 0, unit: '%RH' },
  },
  'kirma-makinasi-2': {
    power: { base: 7.9, amp: 0.14, amp2: 0.06, speed: 1.7, speed2: 3.0, phase: 0.8, historySlope: 0.01, digits: 1, unit: 'kW' },
    airflowInstant: { base: 214, amp: 7, amp2: 3, speed: 1.8, speed2: 2.9, phase: 0.9, historySlope: 0.5, digits: 0, unit: 'L/dk' },
    airTotal: { base: 19250, increment: 41, amp: 5, amp2: 4, speed: 2.1, speed2: 3.2, phase: 0.4, digits: 0, unit: 'L' },
    pressure: { base: 6.1, amp: 0.06, amp2: 0.03, speed: 1.8, speed2: 3.1, phase: 0.6, historySlope: 0.0, digits: 1, unit: 'bar' },
    temperature: { base: 47, amp: 0.5, amp2: 0.2, speed: 2.0, speed2: 3.2, phase: 0.2, historySlope: 0.06, digits: 0, unit: '°C' },
    humidity: { base: 49, amp: 0.5, amp2: 0.4, speed: 2.4, speed2: 3.6, phase: 0.7, historySlope: 0.0, digits: 0, unit: '%RH' },
  },
  'kirma-makinasi-3': {
    power: { base: 7.9, amp: 0.16, amp2: 0.08, speed: 1.5, speed2: 2.7, phase: 0.5, historySlope: 0.16, digits: 1, unit: 'kW' },
    airflowInstant: { base: 214, amp: 8, amp2: 4, speed: 1.6, speed2: 2.4, phase: 0.3, historySlope: 9.5, digits: 0, unit: 'L/dk' },
    airTotal: { base: 24100, increment: 96, amp: 9, amp2: 6, speed: 2.2, speed2: 3.0, phase: 0.2, digits: 0, unit: 'L' },
    pressure: { base: 6.15, amp: 0.07, amp2: 0.03, speed: 1.7, speed2: 2.5, phase: 0.6, historySlope: -0.13, digits: 1, unit: 'bar' },
    temperature: { base: 47, amp: 0.45, amp2: 0.2, speed: 1.8, speed2: 2.9, phase: 0.4, historySlope: 0.9, digits: 0, unit: '°C' },
    humidity: { base: 47, amp: 0.7, amp2: 0.4, speed: 2.1, speed2: 3.5, phase: 0.9, historySlope: 0.0, digits: 0, unit: '%RH' },
  },
  'kirma-makinasi-4': {
    power: { base: 8.7, amp: 0.18, amp2: 0.08, speed: 1.7, speed2: 2.9, phase: 0.6, historySlope: 0.05, digits: 1, unit: 'kW' },
    airflowInstant: { base: 242, amp: 7, amp2: 3, speed: 1.8, speed2: 3.0, phase: 0.2, historySlope: 1.1, digits: 0, unit: 'L/dk' },
    airTotal: { base: 20050, increment: 48, amp: 5, amp2: 4, speed: 2.0, speed2: 3.1, phase: 0.5, digits: 0, unit: 'L' },
    pressure: { base: 5.9, amp: 0.07, amp2: 0.03, speed: 1.9, speed2: 3.2, phase: 0.4, historySlope: -0.03, digits: 1, unit: 'bar' },
    temperature: { base: 53, amp: 0.6, amp2: 0.3, speed: 1.7, speed2: 2.8, phase: 0.8, historySlope: 0.35, digits: 0, unit: '°C' },
    humidity: { base: 52, amp: 0.8, amp2: 0.4, speed: 2.3, speed2: 3.4, phase: 0.7, historySlope: 0.0, digits: 0, unit: '%RH' },
  },
  'kirma-makinasi-5': {
    power: { base: 7.1, amp: 0.1, amp2: 0.04, speed: 2.0, speed2: 3.3, phase: 0.1, historySlope: 0.01, digits: 1, unit: 'kW' },
    airflowInstant: { base: 187, amp: 5, amp2: 2, speed: 1.9, speed2: 3.2, phase: 0.3, historySlope: 0.4, digits: 0, unit: 'L/dk' },
    airTotal: { base: 17980, increment: 35, amp: 4, amp2: 3, speed: 2.4, speed2: 3.5, phase: 0.2, digits: 0, unit: 'L' },
    pressure: { base: 6.3, amp: 0.05, amp2: 0.03, speed: 1.8, speed2: 3.1, phase: 0.5, historySlope: 0.0, digits: 1, unit: 'bar' },
    temperature: { base: 43, amp: 0.4, amp2: 0.2, speed: 2.2, speed2: 3.0, phase: 0.6, historySlope: 0.05, digits: 0, unit: '°C' },
    humidity: { base: 45, amp: 0.5, amp2: 0.3, speed: 2.5, speed2: 3.7, phase: 0.4, historySlope: 0.0, digits: 0, unit: '%RH' },
  },
};

function roundValue(value, digits = 0) {
  return Number(value.toFixed(digits));
}

function formatNumber(value, digits = 0) {
  return new Intl.NumberFormat('tr-TR', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(value);
}

function formatMetric(key, value) {
  if (key === 'power') return `${formatNumber(value, 1)} kW`;
  if (key === 'airflowInstant') return `${formatNumber(value, 0)} L/dk`;
  if (key === 'airTotal') return `${formatNumber(value, 0)} L`;
  if (key === 'pressure') return `${formatNumber(value, 1)} bar`;
  if (key === 'temperature') return `${formatNumber(value, 0)} °C`;
  if (key === 'humidity') return `%${formatNumber(value, 0)} RH`;
  return String(value);
}

function getRangeConfig(timeRangeKey) {
  return TIME_RANGE_OPTIONS.find((item) => item.key === timeRangeKey) || TIME_RANGE_OPTIONS[0];
}

function smoothFactor(minutesAgo, windowMinutes) {
  if (minutesAgo >= windowMinutes) return 0;
  const progress = 1 - minutesAgo / windowMinutes;
  return progress * progress * (3 - 2 * progress);
}

function buildIncidentOffset(machineId, sensorKey, minutesAgo) {
  if (machineId === 'kirma-makinasi-3') {
    const main = smoothFactor(minutesAgo, 95);
    const fast = smoothFactor(minutesAgo, 12);

    const offsets = {
      pressure: -1.25 * main - 0.08 * fast,
      airflowInstant: 98 * main + 10 * fast,
      power: 1.55 * main + 0.18 * fast,
      temperature: 10.8 * main + 0.7 * fast,
      humidity: 0.4 * main,
    };

    return offsets[sensorKey] || 0;
  }

  if (machineId === 'kirma-makinasi-4') {
    const main = smoothFactor(minutesAgo, 240);
    const fast = smoothFactor(minutesAgo, 20);

    const offsets = {
      pressure: -0.18 * main,
      airflowInstant: 18 * main + 4 * fast,
      power: 0.55 * main,
      temperature: 5.2 * main + 0.5 * fast,
      humidity: 0.8 * main,
    };

    return offsets[sensorKey] || 0;
  }

  return 0;
}

function buildOscillation(profile, timestampMs) {
  const hours = timestampMs / 3600000;
  const minutes = timestampMs / 60000;

  return (
    Math.sin(hours / (profile.speed * 1.6) + profile.phase) * profile.amp * 0.55 +
    Math.cos(hours / (profile.speed2 * 2.2) + profile.phase) * profile.amp2 * 0.45 +
    Math.sin(minutes / (profile.speed * 3.6) + profile.phase) * profile.amp * 0.12
  );
}

function computeInstantValue(machineId, sensorKey, timestampMs, nowMs) {
  const profile = profiles[machineId][sensorKey];
  const minutesAgo = Math.max((nowMs - timestampMs) / 60000, 0);
  const oscillation = buildOscillation(profile, timestampMs);
  const incidentOffset = buildIncidentOffset(machineId, sensorKey, minutesAgo);

  return roundValue(profile.base + oscillation + incidentOffset, profile.digits);
}

function getShiftStart(nowMs) {
  const shiftStart = new Date(nowMs);
  shiftStart.setHours(8, 0, 0, 0);
  if (shiftStart.getTime() > nowMs) {
    shiftStart.setDate(shiftStart.getDate() - 1);
  }
  return shiftStart.getTime();
}

function computeAirTotalValue(machineId, timestampMs, nowMs) {
  const profile = profiles[machineId].airTotal;
  const shiftStartMs = getShiftStart(nowMs);
  const effectiveTimestamp = Math.max(timestampMs, shiftStartMs);
  const minutesSincePoint = Math.max((nowMs - effectiveTimestamp) / 60000, 0);
  const currentValue = profile.base;
  const averageRatePerMinute = profile.increment * 0.44;
  const oscillation = Math.sin(effectiveTimestamp / 3600000 / 2.4 + profile.phase) * profile.amp * 2.6;
  const recentBoost = buildIncidentOffset(machineId, 'airflowInstant', Math.max((nowMs - effectiveTimestamp) / 60000, 0)) * 0.28;

  return roundValue(Math.max(currentValue - minutesSincePoint * averageRatePerMinute + oscillation - recentBoost, 0), 0);
}

function buildSensorSeries(machineId, sensorKey, nowMs, rangeConfig) {
  const { points, stepSeconds } = rangeConfig;

  if (sensorKey === 'airTotal') {
    return Array.from({ length: points }, (_, index) => {
      const stepsBack = points - 1 - index;
      const pointTimestamp = nowMs - stepsBack * stepSeconds * 1000;
      return computeAirTotalValue(machineId, pointTimestamp, nowMs);
    });
  }

  return Array.from({ length: points }, (_, index) => {
    const stepsBack = points - 1 - index;
    const pointTimestamp = nowMs - stepsBack * stepSeconds * 1000;
    return computeInstantValue(machineId, sensorKey, pointTimestamp, nowMs);
  });
}

function buildLiveMachine(machine, nowMs, rangeConfig, miniRangeConfig) {
  const powerSeries = buildSensorSeries(machine.id, 'power', nowMs, rangeConfig);
  const airflowSeries = buildSensorSeries(machine.id, 'airflowInstant', nowMs, rangeConfig);
  const airTotalSeries = buildSensorSeries(machine.id, 'airTotal', nowMs, rangeConfig);
  const pressureSeries = buildSensorSeries(machine.id, 'pressure', nowMs, rangeConfig);
  const temperatureSeries = buildSensorSeries(machine.id, 'temperature', nowMs, rangeConfig);
  const humiditySeries = buildSensorSeries(machine.id, 'humidity', nowMs, rangeConfig);
  const miniPressureSeries = buildSensorSeries(machine.id, 'pressure', nowMs, miniRangeConfig);

  const currentMetrics = {
    power: powerSeries[powerSeries.length - 1],
    airflowInstant: airflowSeries[airflowSeries.length - 1],
    airTotal: airTotalSeries[airTotalSeries.length - 1],
    pressure: pressureSeries[pressureSeries.length - 1],
    temperature: temperatureSeries[temperatureSeries.length - 1],
    humidity: humiditySeries[humiditySeries.length - 1],
  };

  return {
    ...machine,
    lastSeen: 'az önce',
    power: formatMetric('power', currentMetrics.power),
    airflowInstant: formatMetric('airflowInstant', currentMetrics.airflowInstant),
    airTotal: formatMetric('airTotal', currentMetrics.airTotal),
    pressure: formatMetric('pressure', currentMetrics.pressure),
    temperature: formatMetric('temperature', currentMetrics.temperature),
    humidity: formatMetric('humidity', currentMetrics.humidity),
    rawMetrics: currentMetrics,
    miniTrend: miniPressureSeries.slice(-7),
    sensorSeries: {
      power: powerSeries,
      airflowInstant: airflowSeries,
      airTotal: airTotalSeries,
      pressure: pressureSeries,
      temperature: temperatureSeries,
      humidity: humiditySeries,
    },
  };
}

function buildDynamicAlerts(machine) {
  if (machine.id === 'kirma-makinasi-3') {
    return [
      {
        id: 1,
        title: 'Kombine Pnömatik Alarm',
        severity: 'Kritik',
        severityColor: '#ff5f57',
        meta: `Anlık hava akışı ${machine.airflowInstant}, basınç ${machine.pressure}`,
        status: 'Canlı güncellendi • şimdi',
      },
      {
        id: 2,
        title: 'Sıcaklık Yükseliyor',
        severity: 'Uyarı',
        severityColor: '#ffb44c',
        meta: `Anlık sıcaklık ${machine.temperature}, elektrik gücü ${machine.power}`,
        status: 'Operatör notu açık • şimdi',
      },
    ];
  }

  if (machine.id === 'kirma-makinasi-4') {
    return [
      {
        id: 1,
        title: 'Sıcaklık Sınır Üstüne Yaklaşıyor',
        severity: 'Uyarı',
        severityColor: '#ffb44c',
        meta: `Anlık sıcaklık ${machine.temperature}, basınç ${machine.pressure}`,
        status: 'İzleme aktif • şimdi',
      },
    ];
  }

  return [];
}

function buildDynamicTimeline(machine, fallbackTimeline) {
  if (machine.id === 'kirma-makinasi-3') {
    return [
      { time: 'şimdi', type: 'critical', label: 'Kombine pnömatik alarm sürüyor', detail: `${machine.airflowInstant} ve ${machine.pressure}` },
      { time: '2 dk önce', type: 'warning', label: 'Sıcaklık artışı devam ediyor', detail: `Anlık değer ${machine.temperature}` },
      { time: '4 dk önce', type: 'warning', label: 'Basınç düşüşü hızlandı', detail: `Elektrik gücü ${machine.power}` },
      { time: '6 dk önce', type: 'info', label: 'Operatör takibi başlatıldı', detail: 'Kontrol listesi açıldı' },
    ];
  }

  if (machine.id === 'kirma-makinasi-4') {
    return [
      { time: 'şimdi', type: 'warning', label: 'Sıcaklık üst sınıra yakın', detail: `${machine.temperature} ölçüldü` },
      { time: '3 dk önce', type: 'info', label: 'Soğutma kontrol edildi', detail: 'Fan ve hava sirkülasyonu gözlendi' },
      { time: '10 dk önce', type: 'normal', label: 'Makine üretime devam etti', detail: `${machine.pressure} ve ${machine.airflowInstant}` },
    ];
  }

  return fallbackTimeline;
}

function buildDynamicScenario(machine, baseScenario) {
  if (machine.id === 'kirma-makinasi-3') {
    return {
      ...baseScenario,
      detail: `Anlık hava akışı ${machine.airflowInstant}, basınç ${machine.pressure}, elektrik gücü ${machine.power}. Son birkaç dakikada sapma sürüyor.`,
    };
  }

  if (machine.id === 'kirma-makinasi-4') {
    return {
      ...baseScenario,
      detail: `Anlık sıcaklık ${machine.temperature} seviyesinde. Basınç ${machine.pressure} ile halen üretimde ancak erken müdahale öneriliyor.`,
    };
  }

  return {
    ...baseScenario,
    detail: `Anlık değerler: ${machine.pressure}, ${machine.airflowInstant}, ${machine.power}. Makine nominal çalışma aralığında.`,
  };
}

function buildPriorityItems(liveMachines) {
  const alarmMachine = liveMachines.find((machine) => machine.id === 'kirma-makinasi-3');
  const warningMachine = liveMachines.find((machine) => machine.id === 'kirma-makinasi-4');

  return [
    {
      id: 'alarm-kirma-3',
      to: '/machine-admin/machines/kirma-makinasi-3',
      title: 'Kritik alarm: Kırma Makinası 3',
      description: `Hava akışı ${alarmMachine.airflowInstant}, basınç ${alarmMachine.pressure}. Kombine pnömatik alarm aktif.`,
      tone: '#ff5f57',
      chip: 'Hemen incele',
    },
    {
      id: 'warning-kirma-4',
      to: '/machine-admin/machines/kirma-makinasi-4',
      title: 'Uyarı: Kırma Makinası 4',
      description: `Sıcaklık ${warningMachine.temperature} seviyesinde. Erken müdahale ile alarm önlenebilir.`,
      tone: '#ffb44c',
      chip: 'İzlemeye al',
    },
  ];
}

function buildLiveDetail(machineId, liveMachines) {
  const machine = liveMachines.find((item) => item.id === machineId) || liveMachines[0];
  const baseScenario = detailScenarios[machine.id] || detailScenarios['kirma-makinasi-1'];
  const fallbackDetail = machineDetailData[machine.id] || {};
  const activeAlerts = buildDynamicAlerts(machine);
  const timeline = buildDynamicTimeline(machine, fallbackDetail.timeline || []);
  const scenario = buildDynamicScenario(machine, baseScenario);

  return {
    ...machine,
    ...scenario,
    activeAlerts,
    timeline,
    sensorCharts: {
      pressure: {
        label: 'Basınç',
        unit: 'bar',
        color: machine.id === 'kirma-makinasi-4' ? '#ffb44c' : '#ff5f57',
        thresholdLabel: 'Alt sınır 5.4 bar',
        thresholdValue: 5.4,
        values: machine.sensorSeries.pressure,
      },
      airflowInstant: {
        label: 'Hava Akışı',
        unit: 'L/dk',
        color: '#38bdf8',
        thresholdLabel: 'Üst sınır 260 L/dk',
        thresholdValue: 260,
        values: machine.sensorSeries.airflowInstant,
      },
      power: {
        label: 'Elektrik Gücü',
        unit: 'kW',
        color: '#f59e0b',
        thresholdLabel: 'Üst sınır 8.8 kW',
        thresholdValue: 8.8,
        values: machine.sensorSeries.power,
      },
      temperature: {
        label: 'Sıcaklık',
        unit: '°C',
        color: '#fb7185',
        thresholdLabel: 'Üst sınır 55 °C',
        thresholdValue: 55,
        values: machine.sensorSeries.temperature,
      },
      humidity: {
        label: 'Nem',
        unit: '%RH',
        color: '#22c55e',
        thresholdLabel: null,
        thresholdValue: null,
        values: machine.sensorSeries.humidity,
      },
      airTotal: {
        label: 'Toplam Hava Tüketimi',
        unit: 'L',
        color: '#a78bfa',
        thresholdLabel: null,
        thresholdValue: null,
        values: machine.sensorSeries.airTotal,
      },
    },
  };
}

function buildChartTimes(now, rangeConfig) {
  const { points, stepSeconds, format } = rangeConfig;
  const formatter = new Intl.DateTimeFormat('tr-TR', {
    ...format,
    hour12: false,
  });

  return Array.from({ length: points }, (_, index) => {
    const stepsBack = points - 1 - index;
    const pointTime = new Date(now.getTime() - stepsBack * stepSeconds * 1000);
    return formatter.format(pointTime);
  });
}

export default function useMockMachineObserver(machineId, timeRangeKey = '1m') {
  const [tick, setTick] = React.useState(0);
  const [now, setNow] = React.useState(() => new Date());

  React.useEffect(() => {
    const intervalId = window.setInterval(() => {
      setTick((current) => current + 1);
      setNow(new Date());
    }, 2000);

    return () => window.clearInterval(intervalId);
  }, []);

  const rangeConfig = getRangeConfig(timeRangeKey);
  const miniRangeConfig = getRangeConfig('1m');
  const nowMs = now.getTime();
  const liveMachines = machineTemplates.map((machine) => buildLiveMachine(machine, nowMs, rangeConfig, miniRangeConfig));
  const priorityItems = buildPriorityItems(liveMachines);
  const liveDetail = buildLiveDetail(machineId || liveMachines[0].id, liveMachines);
  const chartTimes = buildChartTimes(now, rangeConfig);

  return {
    tick,
    now,
    chartTimes,
    timeRangeConfig: rangeConfig,
    liveMachines,
    priorityItems,
    liveDetail,
  };
}
